<p class="form-header" *ngIf="!sessionService.hasRole(RoleType.ADMIN)">
  Your role does not allow for saving settings changes on this screen.
</p>
<cw-ci-data-table #userDataTable
  tileTitle="Api Keys"
  addToolTip="Create a new api key"
  refreshToolTip="Reload api key list"
  skipInitialLoad="true"
  (loadItemsHandler)="loadApiKeys($event)"
  (addHandler)="addKey($event)"
  [items]="apiKeyList">

  <cw-ci-table-column columnName="publicKey" columnTitle="Public Key"></cw-ci-table-column>
  <cw-ci-table-column columnName="privateKeyHash" columnTitle="Private Key"></cw-ci-table-column>
  <cw-ci-table-column columnName="isActive" columnTitle="Active"></cw-ci-table-column>

  <cw-ci-table-column columnName="createdAt" columnTitle="Created" [output]="createdAtTemplate"></cw-ci-table-column>
  <ng-template let-element #createdAtTemplate>{{element.createdAt | date:'mediumDate':'+0000'}}</ng-template>
</cw-ci-data-table>